// extracted by mini-css-extract-plugin
export var whiteBackground = "landing-module--white-background--vfcxn";
export var textCenter = "landing-module--text-center--3R5-6";
export var indiumBannerImage = "landing-module--indium-banner-image--1aCYZ";
export var indiumCtaBanner = "landing-module--indium-cta-banner--2djcV";
export var titleContainer = "landing-module--title-container--2ap7X";
export var agentScoreDisplay = "landing-module--agent-score-display--2vPIW";